import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const GlobalInquiryRemoveContributorNotifCover = ({ notification, sender }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `(ت)قام ${sender?.name} بحذفك من قائمة المشاركين و كذلك قناة المشاركة الخاصة برؤيته/رؤيتها`
          : `${sender?.name} has removed you from his(her) global inquiry contributors list and the associated channel`
      }
    />
  )
}

export default GlobalInquiryRemoveContributorNotifCover
